import { isUUID } from '@vrplatform/utils';

type OwnerAccess = {
  contactId?: string;
  ownerId?: string;
  tenantId?: string;
  role?: string;
};

function isOwnerAccessMatch(access: OwnerAccess, contactId: string) {
  return access.contactId === contactId || access.ownerId === contactId;
}

export function filterOwnerAccessByTeam({
  ownerAccess,
  teamId,
}: {
  ownerAccess: OwnerAccess[];
  teamId: string | null | undefined;
}) {
  if (!teamId) return ownerAccess;

  return ownerAccess.filter((item) => item.tenantId === teamId);
}

export function resolveOwnerPortalContactId({
  ownerAccess,
  teamId,
  contactId,
  queryContactId,
}: {
  ownerAccess: OwnerAccess[];
  teamId: string | null | undefined;
  contactId: string | null;
  queryContactId: string | null;
}) {
  const scopedOwnerAccess = filterOwnerAccessByTeam({
    ownerAccess,
    teamId,
  });

  const hasAccessTo = (id: string | null) =>
    !!id && scopedOwnerAccess.some((access) => isOwnerAccessMatch(access, id));

  if (queryContactId && hasAccessTo(queryContactId)) {
    return queryContactId;
  }

  if (scopedOwnerAccess.length === 1) {
    const firstAccess = scopedOwnerAccess[0];
    return firstAccess?.contactId || firstAccess?.ownerId || null;
  }

  if (hasAccessTo(contactId)) {
    return contactId;
  }

  return null;
}

export function hasOwnerContactAdminAccess({
  ownerAccess,
  teamId,
  contactId,
}: {
  ownerAccess: OwnerAccess[];
  teamId: string | null | undefined;
  contactId: string | null | undefined;
}) {
  if (!contactId) return false;

  return filterOwnerAccessByTeam({ ownerAccess, teamId }).some(
    (access) => isOwnerAccessMatch(access, contactId) && access.role === 'admin'
  );
}

export function isOwnerPreviewTeamSwitchPending({
  queryTeamId,
  activeTeamId,
}: {
  queryTeamId: string | null;
  activeTeamId: string | null | undefined;
}) {
  if (!queryTeamId || !isUUID(queryTeamId)) return false;

  return queryTeamId !== activeTeamId;
}
